import { FC } from 'react';
import { Badge } from '../../../shared/uiComponents';
import { InsuranceDetailProperties } from '../../../redux/API/ClientAPIHelpers/insuranceProperties';
import { getBranchBadgeType } from '../../../shared/Helpers/constants';

interface InsuranceHeaderProps {
	insurance: InsuranceDetailProperties;
}

const InsuranceHeader: FC<InsuranceHeaderProps> = ({ insurance }) => {
	const getInsuranceTypeLabel = () => {
		if (insurance.isOutOfNetwork) return 'Out of Network';
		if (insurance.canBeAssigned) return 'In Network';

		return 'Not Assignable';
	};

	const getInsuranceTypeColor = () => {
		if (insurance.isOutOfNetwork) return 'warning';
		if (insurance.canBeAssigned) return 'success';

		return 'gray';
	};

	return (
		<div
			style={{
				display: 'flex',
				gap: '8px',
				flexWrap: 'wrap',
				marginBottom: '20px',
			}}
		>
			<Badge
				label={insurance.isActive ? 'Active' : 'Inactive'}
				type={insurance.isActive ? 'success' : 'gray'}
				sizeType="md"
			/>
			<Badge label={getInsuranceTypeLabel()} type={getInsuranceTypeColor()} sizeType="md" />
			{insurance.branches &&
				insurance.branches.length > 0 &&
				insurance.branches.map((branch) => (
					<Badge key={branch.id} label={branch.name} type={getBranchBadgeType(branch.state)} sizeType="md" />
				))}
		</div>
	);
};

export default InsuranceHeader;
